<div class="cms-login">
  <aside class="cms-login-panel">
    <div class="cms-login-panel-title">Business Gaming CMS</div>
  </aside>

  <main class="cms-login-main">
    <form class="cms-login-form" [formGroup]="userform" (ngSubmit)="onSubmit()">
      <img class="cms-login-logo" src="assets/img/logo.png" alt="" />

      <label for="username-input" class="cms-login-field">
        <fa-icon [icon]="['fas','user']"></fa-icon>
        <input formControlName="username" aria-label="Username" type="text" placeholder="Username" id="username-input" required />
      </label>
      <label for="password-input" class="cms-login-field">
        <fa-icon [icon]="['fas','lock']"></fa-icon>
        <input formControlName="password" type="password" placeholder="Password" id="password-input" required />
      </label>

      <button type="submit" class="cms-login-submit" [disabled]="!userform.valid || loading">Login</button>
    </form>
  </main>
</div>
